<template>
  <div class="user">
    <div class="" v-loading="loading">
      <div class="s_wrapper">
        <el-input class="s_input" v-model="orderNum" placeholder="请输入订单编号" suffix-icon="el-icon-search" @change="onSearch" clearable></el-input>
        <el-input class="s_input" v-model="parentName" placeholder="请输入大团长名称" suffix-icon="el-icon-search" @change="onSearch" clearable></el-input>
        <el-input class="s_input" v-model="userName" placeholder="请输入下级用户名称" suffix-icon="el-icon-search" @change="onSearch" clearable></el-input>
      </div>

      <div class="g_table">
        <el-table :data="tableData" style="width: 100%" max-height="540">
          <el-table-column label="序号" show-overflow-tooltip width="80">
            <template slot-scope="scope">
              {{ scope.$index + 1 + (currentPage - 1) * pageSize }}
            </template>
          </el-table-column>
          <el-table-column min-width="140" show-overflow-tooltip prop="orderNum" label="订单编号"></el-table-column>
          <el-table-column min-width="120" show-overflow-tooltip prop="orderSource" label="订单类型">
            <template slot-scope="scope">
              <span>{{ orderTypeOptions[scope.row.orderSource] }}</span>
            </template>
          </el-table-column>
          <el-table-column min-width="120" show-overflow-tooltip prop="parentName" label="大团长名称"></el-table-column>
          <el-table-column min-width="120" show-overflow-tooltip prop="userName" label="下级用户名称"></el-table-column>
          <el-table-column min-width="120" show-overflow-tooltip prop="payAmount" label="订单金额(元)"></el-table-column>
          <el-table-column min-width="100" show-overflow-tooltip prop="settlementType" label="结算类型">
            <template slot-scope="scope">
              <span>{{ settleTypeOptions[scope.row.settlementType] }}</span>
            </template>
          </el-table-column>
          <el-table-column min-width="120" show-overflow-tooltip prop="commissionRatio" label="提成比例(%)"></el-table-column>
          <el-table-column min-width="120" show-overflow-tooltip prop="commissionAmount" label="结算金额">
            <template slot-scope="scope">
              <span v-if="scope.row.settlementType == 1">+{{ scope.row.commissionAmount }}</span>
              <span v-if="scope.row.settlementType == 2">-{{ scope.row.commissionAmount }}</span>
            </template>
          </el-table-column>
          <el-table-column min-width="120" show-overflow-tooltip prop="payTime" label="结算时间"></el-table-column>
        </el-table>
      </div>
    </div>

    <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize" :page-sizes="pageSizeArr" layout="prev, pager, next, jumper, sizes, total" :total="totalCount"></el-pagination>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      parentName: "",
      userName: "",
      orderNum: "",
      tableData: [],
      currentPage: 1,
      pageSize: 10,
      pageSizeArr: [10, 20, 50],
      totalCount: 0,
      settleTypeOptions: { 1: "收入", 2: "退款" },
      orderTypeOptions: { 1: "正式项目订单", 2: "体验项目订单", 3: "套餐项目订单", 4: "商品订单" },
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async getList() {
      this.loading = true
      try {
        const {
          result: { list, totalCount },
        } = await this.$axios.get(this.$api.orderIncomePageList, {
          params: {
            parentName: this.parentName || null,
            userName: this.userName || null,
            orderNum: this.orderNum || null,
            // dateType: null, //日期类型：1：今天 2：本周 3本月
            page: this.currentPage,
            pageSize: this.pageSize,
          },
        })
        this.tableData = list
        this.totalCount = totalCount
      } catch (err) {
        this.$message.error(err.desc)
      } finally {
        this.loading = false
      }
    },
    // 搜索
    onSearch() {
      this.tableData = []
      this.currentPage = 1
      this.getList()
    },
    // 切换每页显示的条数
    handleSizeChange(e) {
      this.tableData = []
      this.pageSize = e
      this.getList()
    },
    // 换页
    handleCurrentChange(e) {
      this.tableData = []
      this.currentPage = e
      this.getList()
    },
  },
}
</script>

<style scoped lang="scss">
.user {
  .disabled_user_account {
    width: 255px;
    color: #c0c4cc;
    padding: 0 15px;
    border-radius: 10px;
    background-color: #f5f7fa;
    box-sizing: border-box;
    cursor: not-allowed;
  }
}
</style>
